import Cookies from 'js-cookie'

const TokenKey = 'token'
const globalTokenKey = 'global_token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { expires: 10 })
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function setGlobalToken (token) {
  return Cookies.set(globalTokenKey, token, { expires: 10, domain: 'fzzht.com'})
}

export function getGlobalToken () {
  return Cookies.get(globalTokenKey)
}

export function removeGlobalToken () {
  return Cookies.remove(globalTokenKey, { domain: 'fzzht.com' })
}

export function clearLoginData () {
  removeToken();
  removeGlobalToken();
  sessionStorage.clear();
  // localStorage.clear();
  localStorage.removeItem('user');
  localStorage.removeItem('user_add');
}



// WEBPACK FOOTER //
// ./src/utils/auth.js